<template>
  <div class="editor">
    <div ref="wangeditorRef"></div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { getCookie } from '@/utils'
  import E from "wangeditor"
  import {Message} from "element-ui";
  export default {
    name: 'editor',
    props:{
      desc:{
        type:String,
        default:""
      },
      //业务中我们经常会有添加操作和编辑操作，添加操作时，我们需清除上一操作留下的缓存
      isClear:{
        type:Boolean,
        default:false
      },
      // 图片上传是否插入全路径
      isUploadImgFullPath:{
        type:Boolean,
        default:false
      },
      // 图片上传全路径拼接base
      uploadImgFullPathBase:{
        type:String,
        default:''
      },
      editAble:{
        type:Boolean,
        default:true
      },
    },
    data(){
      return{
        content:"",
        editor: null,
        info_:null
      }
    },

    model: {
      prop: 'desc',
      event:'change'
    },
    watch:{
      editAble(val){
        if( this.editor && this.editor.$textElem)this.editor.$textElem.attr('contenteditable', val);	//设置不可编辑 false  未不可编辑
      },
      isClear(val){
        // console.log(val)
        if (val){
          this.editor.txt.clear()
          // this.info_=null
        }
      },
      desc(value) {
        //console.log("desc",value)
        if (value != this.editor.txt.html()) {
          this.editor.txt.html(this.desc)
        }
      }
    },


    methods:{
      initE(){
        const _this = this;
        this.editor = new E(this.$refs.wangeditorRef);

        this.editor.config.onchangeTimeout = 1000 // 单位 ms
        this.editor.config.uploadFileName = 'file'
        this.editor.config.uploadImgServer = baseURL + '/attachment/uploadFile'  // 你的服务器地址
        this.editor.config.uploadImgMaxSize = 10 * 1024 * 1024
        this.editor.config.uploadImgMaxLength = 5
        this.editor.config.uploadFileName = 'xlsFile'
        this.editor.config.uploadImgHooks = {
          before: function (xhr, editor, files) {
            // 图片上传之前触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
            xhr.setRequestHeader("access_token",  getCookie('access_token'))
            // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
            // return {
            //     prevent: true,
            //     msg: '放弃上传'
            // }
          },
          success: function (xhr, editor, result) {
            // 图片上传并返回结果，图片插入成功之后触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
          },
          fail: function (xhr, editor, result) {
            // 图片上传并返回结果，但图片插入错误时触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
          },
          error: function (xhr, editor) {
            // 图片上传出错时触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
          },
          timeout: function (xhr, editor) {
            // 图片上传超时时触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
          },

          // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
          // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
          customInsert: function (insertImg, result, editor) {
            // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
            // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
            // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：

            if(result.code == 1){
              var url = result.data.filepath;
              if(_this.isUploadImgFullPath){
                var base = window.location.protocol + '//'+location.host;
                url = this.uploadImgFullPathBase||base + url;
              }
              insertImg(url)
            }else{
              Message.error('暂不可编辑。')
            }
            // result 必须是一个 JSON 格式字符串！！！否则报错
          }
        }
        this.editor.config.onchange = (html) => {
          this.info_ = html // 绑定当前逐渐地值
          this.$emit('change', this.info_) // 将内容同步到父组件中
        }
        this.editor.config.menus = [
          'head',  // 标题
          'bold',  // 粗体
          'fontSize',  // 字号
          'fontName',  // 字体
          'italic',  // 斜体
          'underline',  // 下划线
          'strikeThrough',  // 删除线
          'foreColor',  // 文字颜色
          'backColor',  // 背景颜色
          'link',  // 插入链接
          'list',  // 列表
          'justify',  // 对齐方式
          'quote',  // 引用
          'emoticon',  // 表情
          'image',  // 插入图片
          'table',  // 表格
          'code',  // 插入代码
          'undo',  // 撤销
          'redo'  // 重复
        ]
        this.editor.create()
        this.editor.$textElem.attr('contenteditable', this.editAble);	//设置不可编辑 false  未不可编辑

        // this.editor.txt.html(this.desc)
        //  this.editor.txt.html(this.desc)
      }
    },
    activated() {
      this.initE();
    },
    mounted () {

    }
  }
</script>

<style scoped>

</style>